export default "__VITE_ASSET__DYStUVmQ__"